import { useSelector } from 'react-redux'

import {
  selectAllAgreementForms,
  useGetFormsOnMount,
} from '@user/store/agreements'

import { AgreementsProps } from './Agreements'

export function useData(params: AgreementsProps) {
  const { entityId, entityType } = params

  const status = useGetFormsOnMount({
    externalEntityId: entityId.toString(),
    externalEntityType: entityType.toString(),
  })

  const agreements = useSelector(selectAllAgreementForms)

  const agreementCount = status === 'success' ? `(${agreements.length})` : ''

  const title = `Agreements ${agreementCount}`

  return {
    title,
    status,
    agreements,
  }
}
